module.exports = __webpack_public_path__ + "static/img/02-works.0070d2fe.jpg";